export const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
export const FETCH_CUSTOMERS = 'FETCH_CUSTOMERS';
export const FETCH_CUSTOMER_BY_ID = 'FETCH_CUSTOMER_BY_ID';
export const FETCH_CUSTOMERS_CATEGORIES = 'FETCH_CUSTOMERS_CATEGORIES';
export const CUSTOMER_ASYNC_START = 'CUSTOMER_ASYNC_START';
export const CUSTOMER_ASYNC_END = 'CUSTOMER_ASYNC_END';
